<div class="chat-container comments" [ngStyle]="{ height: fullHeight ? '100%' : height ? height + 'px' : null }">
  <div class="messages" #chatWindow>
    <ul class="notes-list">
      @if (videoNotes && videoNotes.length) {
        @for (note of videoNotes; track note.id) {
          <li class="video-note" [class.active]="note.active" [class.pending]="note.pending" [class.send-failed]="note.sendFailed">
            <div>
              <div class="video-note-text t-14" [innerHTML]="note.htmlMessage | safe: 'html'"></div>
              @if (note.pending) {
                <span class="note-status t-11 c-gray d-block m-t-2">Sending...</span>
              } @else if (note.sendFailed) {
                <span class="note-status note-status--failed t-11 d-block m-t-2">Failed to send</span>
              } @else {
                <button class="link t-12 font-weight-bold d-inline-block" (click)="noteOptions(note)">{{ "video_notes.options" | translate }}</button>
              }
            </div>
          </li>
        }
      }
      @if (timedVideoNotes && timedVideoNotes.length) {
        @for (note of timedVideoNotes; track note.id) {
          <li class="video-note" [class.active]="note.active" [class.pending]="note.pending" [class.send-failed]="note.sendFailed">
            @if (note.video_timestamp) {
              <div class="video-timestamp">{{ helperService.hhmmss(note.video_timestamp) }}</div>
            }
            <div>
              <div class="video-note-text t-14" [innerHTML]="note.htmlMessage | safe: 'html'"></div>
              @if (note.pending) {
                <span class="note-status t-11 c-gray d-block m-t-2">Sending...</span>
              } @else if (note.sendFailed) {
                <span class="note-status note-status--failed t-11 d-block m-t-2">Failed to send</span>
              } @else {
                @if (note.video_timestamp) {
                  <button class="link t-12 font-weight-bold d-inline-block m-r-10" (click)="playVideoFrom.next(note.video_timestamp)">{{ "video_notes.play_video_from_here" | translate }}</button>
                }
                <button class="link t-12 font-weight-bold d-inline-block" (click)="noteOptions(note)">{{ "video_notes.options" | translate }}</button>
              }
            </div>
          </li>
        }
      }
    </ul>
    @if (loading) {
      <myp-inline-loader [loading]="true" height="120px" spinnerName="videoNotesLoader"></myp-inline-loader>
    } @else if ((!videoNotes || !videoNotes.length) && (!timedVideoNotes || !timedVideoNotes.length)) {
      <span class="c-white" style="display: flex; align-items: center; height: 100%; text-align: center; justify-content: center">{{ "video_notes.no_notes_yet" | translate }}</span>
    }
  </div>

  <div class="input-container text-left">
    @if (shouldShowActiveTime || isHovering || note) {
      <div class="note-timestamp" (mouseenter)="isHovering = true" (mouseleave)="isHovering = false" [ngStyle]="{ bottom: noteInputHeight + 25 + 'px' }">
        <input id="note-timestamp-check" type="checkbox" [(ngModel)]="linkToTimestamp" class="m-r-5" />
        <label for="note-timestamp-check">{{ "video_notes.link_note_to_timestamp" | translate }} {{ activeTime?.display }}</label>
      </div>
    }
    <div class="msg-input">
      <myp-message-input
        #msgInput
        [type]="'span'"
        inputID="video-notes-input"
        (valueChanged)="noteValueChange($event)"
        (messageSent)="addNote()"
        [placeholder]="'video_notes.ctrl_enter_to_send' | translate"
        (inputHeightChange)="inputHeightChange($event)"
        (blur)="shouldShowActiveTime = false"
        (focus)="shouldShowActiveTime = true"
        [includeSendButton]="true"
        [textSendButton]="true"
        ariaLabelBy="video-label"
      ></myp-message-input>
    </div>
  </div>
</div>
